import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import Button from 'components/ui/button';
import CustomSelect from 'components/custom-select';
import Box from 'components/ui/box';

import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.png';
import { toast } from 'react-toastify';
import { actionLog } from 'services/actionlog.service';
import { getLinkedIndicators } from 'services/profile.service';
import { LinkedIndicators_Indicadores } from 'types/user';

interface Props {
  callback: (action: boolean) => void;
  id: string;
}

const reasons = [
  {
    label: 'Reconhecimento está duplicado',
    value: 'motivo0',
  },
  {
    label: 'Reconhecimento possui informações sigilosas',
    value: 'motivo1',
  },
  {
    label: 'Reconhecimento foi enviado para a pessoa errada',
    value: 'motivo2',
  },
  {
    label: 'Outros',
    value: 'outros',
  },
];

export default function ModalChangeIndicator({ callback, id }: Props) {
  ReactModal.setAppElement('#modal');

  const [sending, setSending] = useState(false);
  const [response, setResponse] = useState<any>();
  const [success, setSuccess] = useState<boolean | undefined>();
  const [indicator, setIndicator] = useState<{ label: string; value: number | string } | undefined>();
  const textOthersRef = useRef<any>();
  const [textOthers, setTextOthers] = useState<string | undefined>();

  const [indicatorsList, setIndicatorsList] = useState<LinkedIndicators_Indicadores[] | undefined>();

  const [indicators, setIndicators] = useState<{ cod: string; nome: number | string }[]>([]);

  const formValid = useMemo(() => {
    return !!indicator && !!indicator?.value && indicator?.value;
  }, [indicator]);

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  const closeModal = () => {
    callback(typeof success === 'boolean' && !!response ? true : false);
  };

  useEffect(() => {
    async function loadData() {
      const data = await getLinkedIndicators();

      if (data?.indicadores?.length) {
        setIndicatorsList(data.indicadores);
      }
    }

    loadData();
  }, []);

  const handleSubmit = async () => {
    if (!formValid || sending) return;

    setSending(true);

    try {
      const { action } = await actionLog('me', 'atualizar_indicador', {
        cod: Number(indicator?.value),
        nome: indicator?.label,
        taskId: id,
      });

      const _success = action?.attributes?.status === 'OK';

      setSuccess(_success);
      setResponse(action);
      setSending(false);
    } catch (error) {
      toast.error(`Ocorreu um erro ao registrar sua ação. Por favor, tente novamente em alguns minutos.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setSending(false);
    }
  };

  if (typeof id !== 'string' || !id.length) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={true}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Devolver/Cancelar reconhecimento"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <Box className={`w-[90%] lg:w-auto lg:max-w-[600px]`}>
            <Button
              color="primary"
              className={`absolute -right-5 -top-5 rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center ${
                sending ? 'opacity-60' : ''
              }`}
              onClick={() => {
                if (!sending) {
                  closeModal();
                }
              }}
              disabled={sending}
              title="Fechar"
            >
              <IoIosClose color="white" size={40} />
            </Button>

            {typeof success === 'boolean' && !!response ? (
              <>
                <div className="w-full lg:w-[260px] flex flex-col items-center justify-center space-y-8">
                  {response.attributes.status === 'OK' ? (
                    <>
                      <div className="flex items-center justify-center">
                        <img src={FeedbackImg} alt="Enviado!" className="w-[173px] block" />
                      </div>

                      <h4 className="block text-2xl font-semibold text-yellow text-center">Mandou bem!</h4>
                    </>
                  ) : (
                    <h4 className="block text-2xl font-semibold text-yellow mb-4 text-center">
                      Não foi possível atualizar a realização!
                    </h4>
                  )}

                  <p className="text-sm font-white font-light text-center block mb-8">{response.attributes.systemMessage}</p>

                  <button
                    className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none`}
                    onClick={() => {
                      closeModal();
                    }}
                  >
                    Fechar
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="w-full lg:w-[536px] flex flex-col items-center justify-center space-y-6">
                  <h4 className="block text-center text-yellow text-lg font-semibold leading-none">Atualize o Indicador desta Realização</h4>

                  <>
                    <p className="text-alice-blue text-base font-thin block w-full text-center">
                      Atualize o indicador da realização para o mais adequado a sua realização.
                    </p>
                   
                  </>

                  <hr className="border-prussian-blue w-full" />

                  <div className="w-full">
                    <label className="text-white font-thin text-xs leading-none mb-2 block">Indicador</label>
                    <CustomSelect
                      className="select-realizacao-destaque"
                      value={indicator}
                      placeholder={'Selecione o indicador'}
                      options={
                        indicatorsList
                          ? indicatorsList.map((item, index: number) => {
                              return {
                                label: item.nome,
                                value: item.cod,
                              };
                            })
                          : [
                              {
                                label: 'Carregando...',
                                value: '',
                              },
                            ]
                      }
                      onChange={(e: any) => [setIndicator(e)]}
                    />
                  </div>

                  <button
                    className={`text-white bg-slate-blue text-sm inline-flex items-center justify-center font-semibold uppercase rounded py-3 px-4 leading-none ${
                      !formValid || sending ? 'opacity-60' : ''
                    }`}
                    onClick={() => handleSubmit()}
                    disabled={!formValid || sending}
                  >
                    Atualizar
                  </button>
                </div>
              </>
            )}
          </Box>
        )}
      />
    </>
  );
}
